module.exports = __webpack_public_path__ + "img/as3.ea9ffc5b.png";